import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({ id: 'setup.startEndRoute.header.title' }),
      description: translate({ id: 'setup.startEndRoute.header.description' }),
    },
    copy: translate({ id: 'setup.startEndRoute.btn.copy' }),
    collect: translate({ id: 'setup.startEndRoute.collect.title' }),
    tracked: translate({ id: 'setup.startEndRoute.collect.tracked' }),
    notTracked: translate({ id: 'setup.startEndRoute.collect.notTracked' }),
    copyTooltip: {
      title: translate({ id: 'setup.startEndRoute.copyTooltip.title' }),
    },
    copySettingsToTerritory: translate({ id: 'setup.startEndRoute.copySettingsToTerritory' }),
    more: translate({ id: 'global.more' }),
  }))

  return api
}
